"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
var core_1 = require("@material-ui/core");
var Menu_1 = __importDefault(require("@material-ui/icons/Menu"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
var Menu_2 = __importDefault(require("./components/Menu"));
var Typography_1 = require("../Typography");
util_localization_1.default.addTranslations('de', {
    'Turn on darkmode': 'Darkmode aktivieren',
    'Turn off darkmode': 'Darkmode deaktivieren',
});
exports.default = react_1.forwardRef(function SimpleAppBar(_a, ref) {
    var _b, _c;
    var onDrawerToggle = _a.onDrawerToggle, _d = _a.open, open = _d === void 0 ? false : _d, _e = _a.color, color = _e === void 0 ? 'primary' : _e, _f = _a.position, position = _f === void 0 ? 'fixed' : _f, _g = _a.title, title = _g === void 0 ? '' : _g, _h = _a.logoLinkElementType, LogoComponent = _h === void 0 ? 'a' : _h, _j = _a.logoLinkHref, logoLinkHref = _j === void 0 ? '/' : _j, _k = _a.disableHideTitleOnMobile, disableHideTitleOnMobile = _k === void 0 ? false : _k, username = _a.username, avatarImage = _a.avatarImage, logoImage = _a.logoImage, showMenuIcon = _a.showMenuIcon, signOut = _a.signOut, search = _a.search, advancedSearch = _a.advancedSearch, _l = _a.disableOffset, disableOffset = _l === void 0 ? false : _l;
    var classes = useStyles();
    var _m = react_1.useState(), anchorEl = _m[0], setAnchorEl = _m[1];
    return (jsx_runtime_1.jsxs("div", __assign({ className: classnames_1.default(classes.root), ref: ref }, { children: [jsx_runtime_1.jsx(AppBar_1.default, __assign({ color: color, position: position, className: classnames_1.default(classes.appBar, (_b = {},
                    _b[classes.appBarShift] = open,
                    _b)) }, { children: jsx_runtime_1.jsxs(Toolbar_1.default, __assign({ disableGutters: !open }, { children: [showMenuIcon && (jsx_runtime_1.jsx(__1.IconButton, __assign({ onClick: onDrawerToggle, color: "inherit", className: classnames_1.default(classes.menuButton, (_c = {},
                                _c[classes.hide] = open,
                                _c)) }, { children: jsx_runtime_1.jsx(Menu_1.default, {}, void 0) }), void 0)),
                        logoImage !== undefined && (jsx_runtime_1.jsx(LogoComponent, __assign({ href: logoLinkHref }, { children: jsx_runtime_1.jsx(__1.Avatar, { alt: "LOGO", src: logoImage, className: classes.logo }, void 0) }), void 0)),
                        Boolean(title) && (jsx_runtime_1.jsx(__1.Grid, __assign({ item: true, className: disableHideTitleOnMobile ? undefined : classes.title }, { children: typeof title === 'string' ? jsx_runtime_1.jsx(Typography_1.H6, { children: title }, void 0) : title }), void 0)),
                        jsx_runtime_1.jsx("div", { className: classes.grow }, void 0),
                        search && (jsx_runtime_1.jsx(__1.SimpleSearch, { color: "onPrimary", searchFieldClass: classes.searchField, searchFieldProps: __assign({
                                focusClassName: classes.searchFieldFocus,
                            }, search), advancedSearch: advancedSearch }, void 0)),
                        (avatarImage !== undefined || username !== undefined) && (jsx_runtime_1.jsxs("div", __assign({ className: classes.menuWrapper }, { children: [signOut !== undefined && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(__1.IconButton, __assign({ size: "small", onClick: function (event) {
                                                setAnchorEl(event.currentTarget);
                                            } }, { children: jsx_runtime_1.jsx(__1.Avatar, { alt: username, name: username, src: avatarImage }, void 0) }), void 0),
                                        jsx_runtime_1.jsx(Menu_2.default, { onClose: function () {
                                                setAnchorEl(undefined);
                                            }, username: username, signOut: signOut, anchorEl: anchorEl }, void 0)] }, void 0)),
                                signOut === undefined && jsx_runtime_1.jsx(__1.Avatar, { alt: username, name: username, src: avatarImage }, void 0)] }), void 0)),
                        avatarImage === undefined && signOut !== undefined && (jsx_runtime_1.jsx(__1.Button, __assign({ variant: "text", color: "inherit", onClick: signOut, className: classes.signOutButton }, { children: util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Logout"], ["Logout"]))) }), void 0))] }), void 0) }), void 0),
            disableOffset === false && position === 'fixed' && jsx_runtime_1.jsx("div", { className: classes.appBarOffset }, void 0)] }), void 0));
});
var drawerWidth = 240;
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return ({
        appBarOffset: theme.mixins.toolbar,
        signOutButton: {
            marginLeft: theme.spacing(2),
        },
        root: {
            display: 'flex',
        },
        menuWrapper: {
            marginLeft: theme.spacing(3),
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: "calc(100% - " + drawerWidth + "px)",
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        grow: {
            flexGrow: 1,
        },
        menuButton: {
            marginLeft: 5,
            marginRight: 20,
        },
        title: (_a = {
                display: 'none'
            },
            _a[theme.breakpoints.up('sm')] = {
                display: 'block',
            },
            _a),
        searchField: {
            '& input': (_b = {
                    transition: theme.transitions.create(['width', 'margin'], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    width: 120
                },
                _b[theme.breakpoints.down('xs')] = {
                    width: 'inherit',
                },
                _b),
        },
        searchFieldFocus: {
            '& input': (_c = {
                    width: 228
                },
                _c[theme.breakpoints.down('xs')] = {
                    width: 'inherit',
                },
                _c),
        },
        hide: {
            display: '100%',
        },
        logo: {
            marginRight: 15,
        },
    });
});
var templateObject_1;
//# sourceMappingURL=SimpleAppBar.js.map